var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 166.10001,
    width: 166.10001,
    viewBox: "0 0 166.1 166.10001",
    "data-name": "Capa 1",
    id: "Capa_1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:#c72e26;}.cls-2,.cls-4{fill:#fff;}.cls-3{fill:#737373;}.cls-4{stroke:#1d1d1b;stroke-miterlimit:10;stroke-width:0.25px;}"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-124.31999,-266.06999)",
    id: "Info"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#c72e26"
    },
    r: 83.050003,
    cy: 349.12,
    cx: 207.37,
    className: "cls-1",
    "data-name": "Elipse 7-2",
    id: "Elipse_7-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M 208.34,386.69 A 36.6,36.6 0 1 0 171.75,350.1 v 0 a 36.59,36.59 0 0 0 36.59,36.59 z m 3,-18.3 h -6.1 V 344 h 6.1 z m -3,-37.35 a 3.81,3.81 0 1 1 -3.81,3.81 3.81,3.81 0 0 1 3.81,-3.85 z",
    className: "cls-2",
    id: "info-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleInfoIcon);
export default __webpack_public_path__ + "static/media/circle-info-icon.891026a5915c4b7ff89233b0ca38d2b1.svg";
export { ForwardRef as ReactComponent };